import { getCachedEmailRecipientLabel } from 'src/components/scheduling2/EmailRecipientLabelCache';
import { getEmailRecipientLabelWithoutInactivePrefix } from 'src/components/scheduling2/EmailSettings.utils';
import { ApiErrorHelper } from 'src/helpers/ApiErrorHelper';
import { IServerError } from 'src/interfaces/ServerError';

import { PROPERTY_SETTINGS_SAVE_LABELS } from '../PropertySettingsSave.labels';

interface PropertySaveErrorAlertDetails {
	title: string;
	errorMessage?: string;
	serverError?: IServerError;
}

const INACTIVE_EMAIL_RECIPIENT_ERROR_PATTERN =
	/User with id=([^\s]+) does not belong to this tenant or is inactive/;

const getInactiveEmailRecipientErrorMessage = (serverError: unknown): string | null => {
	const serverErrorMessage = ApiErrorHelper.getErrorMessage(serverError);
	const inactiveRecipientUserId = serverErrorMessage?.match(
		INACTIVE_EMAIL_RECIPIENT_ERROR_PATTERN
	)?.[1];

	if (!inactiveRecipientUserId) {
		return null;
	}

	const recipientLabel =
		getCachedEmailRecipientLabel(inactiveRecipientUserId) ||
		`User with id=${inactiveRecipientUserId}`;

	return PROPERTY_SETTINGS_SAVE_LABELS.INACTIVE_EMAIL_RECIPIENT_ERROR(
		getEmailRecipientLabelWithoutInactivePrefix(recipientLabel)
	);
};

const getSaveErrorAlertDetails = (
	title: string,
	serverError: unknown
): PropertySaveErrorAlertDetails => {
	const inactiveEmailRecipientErrorMessage = getInactiveEmailRecipientErrorMessage(serverError);

	return {
		title,
		errorMessage: inactiveEmailRecipientErrorMessage || undefined,
		serverError: inactiveEmailRecipientErrorMessage ? undefined : (serverError as IServerError)
	};
};

export const PropertySettingsSaveErrorHelper = {
	getSaveErrorAlertDetails,
	getInactiveEmailRecipientErrorMessage
};
